export const formatReleaseDate = (
  releasedAt: string,
  locales?: Intl.LocalesArgument,
  timeZone?: string,
): string => {
  const date = new Date(releasedAt);
  if (Number.isNaN(date.getTime())) return releasedAt;

  return new Intl.DateTimeFormat(locales, {
    dateStyle: 'medium',
    timeStyle: 'short',
    ...(timeZone === undefined ? {} : { timeZone }),
  }).format(date);
};
